import { FeatureConfig, qcFeatureConfig } from './FeatureConfig'
import { ApplicationConfig, qcApplicationConfig } from './ApplicationConfig'
import { ServiceConfig, qcServiceConfig } from './ServiceConfig'

export const ClientConfig: FeatureConfig & ApplicationConfig & ServiceConfig = {
	...qcFeatureConfig,
	...qcApplicationConfig,
	...qcServiceConfig,
}
